import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAppSelector } from './hooks/store';
import './App.css';
import Home from './pages/Home';
import Login from './pages/Login';
import Event from './pages/Event';
import Cabinet from './pages/Cabinet';
import Attendee from './pages/Attendee';
import InfoView from './pages/InfoView';
import Print from './pages/Print';

function App() {
    const token = useAppSelector(state => state.auth.token);

    return (
        <div className='App'>
            <Routes>
                <Route path='/client'>
                    <Route path=':slug' element={<Event/>} >
                        <Route path='cabinet' element={token ? <Cabinet/> : <Navigate replace to='../login'/>} >
                            <Route path='attendee' element={<Attendee/>} />
                            <Route path='infoview' element={<InfoView/>} />
                            <Route path='print' element={<Print/>} />
                            <Route path='*' element={<Navigate replace to='..'/>} />
                        </Route>
                        <Route path='login' element={<Login/>} />
                        <Route index element={token ? <Navigate replace to='cabinet'/> : <Navigate replace to='login'/>} />
                        <Route path='*' element={<Navigate replace to='login'/>} />
                    </Route>
                    <Route index element={<Home/>} />
                </Route>
                <Route path='*' element={<Navigate replace to='/client'/>} />
            </Routes>
        </div>
    );
}

export default App;
